import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { Store } from '@ngxs/store';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { SharedService } from 'src/app/services/shared.service';
import { Utility, Patterns, Guid } from 'src/app/core/common';
import { SpinnerService } from 'src/app/services/spinner.service';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { Current, Update } from 'src/app/states/auth.state';
import { AutocompleteComponent } from '../autocomplete/autocomplete.component';
import { UserService } from 'src/app/services/user.service';
import { Params } from '@angular/router';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-subscribe-search',
  templateUrl: './subscribe-search.component.html',
  styleUrls: ['./subscribe-search.component.scss']
})
export class SubscribeSearchComponent implements OnInit {
  Utility = Utility;
  patterns = Patterns;
  authCode?: string;
  info: any = {};
  callToActionMode = true;

  constructor(private subscriptionService: SubscriptionService, public sharedService: SharedService,
    private spinner: SpinnerService, private store: Store, public userService: UserService) {

    if (!sharedService.isBrowser) return;
    sharedService.navigationEnd$.pipe(takeUntil(this.unsubscribe$)).subscribe(async () => await this.init());
  }

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  ngOnInit() {
  }

  user: any;
  async init() {
    this.loadUser();
    if (!this.mobile && this.user) this.mobile = this.user.Username;
    this.checkIfSubscribedForCurrent();
    this.callToActionMode = !this.sharedService.isAlreadySubscribed;
  }

  private loadUser() {
    this.user = this.sharedService.me;
    if (this.user) {
      this.mobile = '0' + this.user.Username;
      this.checkIfSubscribedForCurrent();
    }
  }

  private _params: Params;
  get params() { return this._params; }
  @Input() set params(val: Params) {
    val = val || {};
    this._params = val;
    this.showSearchboxInPopup = !val?.q || !val?.l;
    this.checkIfSubscribedForCurrent();
  }


  @Input() mode = 'popup';
  @Input() source = '';
  @Input() expiredPosition? : number;
  @Output() subscribed = new EventEmitter<{ params?: any }>();
  mobile: string;
  showSearchboxInPopup: boolean;
  currentSubscription$ = new BehaviorSubject<any>(null);

  @ViewChild('searchesModal') searchesModal: NgxSmartModalComponent;
  @ViewChild('keywordInput') keywordInput: AutocompleteComponent;

  keyword = '';
  location: any = {};

  checkIfSubscribedForCurrent() {
    if (!this.user || !this.params) {
      this.currentSubscription$.next(null);
      return;
    }
    let searches = this.user.Seeker?.JobAlertSettings?.Searches;
    this.currentSubscription$.next(searches?.find(_ => _.SearchParams?._Url == this.params._Url));
  }

  @ViewChild('mobileInput') mobileInput: ElementRef;

  async toggleSubscribe(event: MouseEvent) {
    if (event) { event.preventDefault(); event.stopPropagation(); } //to prevent double execution when on checkbox click

    if (this.currentSubscription$.value) {
      await this.unsubscribe();
      return;
    }

    if (!this.user || this.showSearchboxInPopup) {
      this.searchesModal.open();
      return;
    }

    await this.subscribe();
  }

  private async unsubscribe() {
    if (!this.currentSubscription$.value?.Token) return;
    await this.subscriptionService.removeForUser(this.currentSubscription$.value.Token);
    this.user.Seeker.JobAlertSettings.Searches = this.user.Seeker.JobAlertSettings.Searches.filter(_ => _.Token != this.currentSubscription$.value?.Token);
    await this.store.dispatch(new Update(this.user, false)).toPromise();
    this.currentSubscription$.next(null);
  }

  async subscribe() {
    if (!this.user)
      this.loadUser();
    if (this.mode == 'popup' && !this.params.q && !this.params.l) return;

    this.spinner.show('sending');
    let subscription = {
      SubscribeSource: this.source,
      SearchParams: this.params,
      Token: Guid.newGuid()
    };
    let result = await this.subscriptionService.saveForUser(subscription);
    this.currentSubscription$.next(result?.Searches.find(_ => _.Token == subscription.Token));
    if (!this.user.Seeker) {
      await (this.store.dispatch(Current)).toPromise();
      this.user = this.sharedService.me;
    } else if(result) {
      if (!this.user.Seeker.JobAlertSettings) this.user.Seeker.JobAlertSettings = {};
      this.user.Seeker.JobAlertSettings.Searches = result.Searches;
    }
    await this.store.dispatch(new Update(this.user, false)).toPromise();
    this.subscribed.emit({ params: Utility.clone(this.params) });
    this.sharedService.isAlreadySubscribed = true;
    this.spinner.hide('sending');

    if (this.mode == 'window') window.close();
    else if (this.user.Seeker?.ExpiredPromote !== false) this.searchesModal.open();
  }

  @Output('close') onClose = new EventEmitter();
  close() {
    this.onClose.emit();
    if (this.mode == 'popup')
      this.searchesModal.close();
    else {
      window.close();
    }
  }
}
